import type { GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { CanvasProvider } from "client/contexts/ResizeEditor/Canvas";
import { Crop } from "components/modules/Editors/Crop/Crop";
import Head from "next/head";
import { translateFunc } from "client/utils/translateFunc";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import { commonLanguageFiles } from "client/config";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";

const Home: NextPage = () => {
    return (
        <>
            <Head>
                <title>{translateFunc("page-title")}</title>
            </Head>
            <ReduxProvider>
                <CanvasProvider>
                    <Crop />
                </CanvasProvider>
            </ReduxProvider>
        </>
    );
};

const files = ["single-resizer-editor", "crop-editor", ...commonLanguageFiles];

const LanguageWrapper = () => (
    <LanguageProvider files={files}>
        <Home />
    </LanguageProvider>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
